import React from 'react';

import { DomainPermission } from '../types/DomainPermission';
import { EditDomainCell } from './EditDomainCell';
import { TextTableCell } from './TextTableCell';

export type DomainTableRowProps = Readonly<{
    rowIndex: number;
    domainName: string;
    poolName: string;
    onEditClicked: () => void;
    onDeleteClicked: () => void;
    domainPermission: DomainPermission;
}>;

export function DomainTableRow(props: DomainTableRowProps) {
    const { rowIndex, domainName, poolName, onEditClicked, onDeleteClicked, domainPermission } = props;
    return (
        <tr key={rowIndex}>
            <TextTableCell testId={'domain-name-cell'} text={domainName} isTextItalicized={false} />
            <TextTableCell testId={'domain-pool-cell'} text={poolName} isTextItalicized={domainPermission === DomainPermission.BLOCK} />
            <EditDomainCell onEditClicked={onEditClicked} onDeleteClicked={onDeleteClicked} />
        </tr>
    );
}

